<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
let xLabel = [
  "2025年2月",
  "2025年4月",
  "2025年6月",
  "2025年8月",
  "2025年10月",
  "2026年1月",
  "2026年3月",

];
let dataValue = [1964, 1461, 1589, 1446, 1634, 2149, 2548];
let dataValue1 = [901, 945, 940, 871, 810, 903, 932];

const option = {
  color: ["#ff974c", "#00eaff"],
  // backgroundColor: "#0c2d55",
  tooltip: {
    trigger: "axis",
    show: false,
    axisPointer: {
      lineStyle: {
        color: "rgb(126,199,255)",
      },
    },
  },
  legend: {
    show: true,
    top: "2%",
    icon: "roundRect",
    itemWidth: 30, // 图例标记的图形宽度。
    itemHeight: 10, //  图例标记的图形高度。
    textStyle: {
      color: "#fff",
      fontSize: 26,
      padding: [0, 8, 0, 8],
    },
  },
  grid: {
    top: "20%",
    left: "10%",
    right: "5%",
    bottom: "15%",
  },
  xAxis: [
    {
      type: "category",
      axisLine: {
        //坐标轴轴线相关设置。数学上的x轴
        show: true,
        lineStyle: {
          color: "rgb(41,188,245)",
        },
      },
      axisLabel: {
        //坐标轴刻度标签的相关设置
        textStyle: {
          color: "#FFFFFF",
          fontSize: 26,
        },
        interval: 0,
        formatter: function (params) {
          var str = ""; // 最终拼接成的字符串
          var paramsLen = params.length; // 获取每项文字的个数
          var len = 5; // 每行能显示的字的个数（根据实际情况自己设置）
          var rowNumber = Math.ceil(paramsLen / len); // 换行的话，需要显示几行，向上取整
          if (paramsLen > len) {
            //大于设定的len就换行，不大于就不变化
            for (var i = 0; i < rowNumber; i++) {
              var temp = ""; // 表示每一次截取的字符串
              var start = i * len; // 开始截取的位置
              var end = start + len; // 结束截取的位置
              if (i == rowNumber - 1) {
                // 最后一次不换行
                temp = params.substring(start, paramsLen);
              } else {
                // 每一次拼接字符串并换行
                temp = params.substring(start, end) + "\n";
              }
              str += temp; // 最终拼成的字符串
            }
          } else {
            // 给新的字符串赋值
            str = params;
          }
          return str; //返回字符串
        },
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "#233653",
        },
      },
      axisTick: {
        show: false,
      },
      data: xLabel,
    },
  ],
  yAxis: [
    {
      name: "单位：元/斤",
      nameTextStyle: {
        color: "#fff",
        fontSize: 26,
        padding: [0, 0, 10, 10],
      },
      // minInterval: 1,
      type: "value",
      splitLine: {
        show: true,
        lineStyle: {
          color: "#1160a0",
          type: "dashed",
        },
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#008de7",
        },
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: "#fff",
          fontSize: 26,
        },
      },
      axisTick: {
        show: false,
      },
    },
  ],
  series: [
    {
      name: "采购热度",
      type: "line",
      smooth: true,

      symbol: "circle", // 默认是空心圆（中间是白色的），改成实心圆
      lineStyle: {
        normal: {
          width: 2,
          color: "#ff974c", // 线条颜色
        },
      },
      itemStyle: {
        normal: {
          label: {
            show: false, //开启显示
            color: "#fff",
            position: "top", //在上方显示
            formatter: function (res) {
              if (res.value) {
                return res.value;
              } else {
                return 0;
              }
            },
          },
        },
      },
      symbolSize: 0, //设定实心点的大小
      areaStyle: {
        normal: {
          //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "#ff974c30",
              },
              {
                offset: 0.6,
                color: "#ff974c20",
              },
              {
                offset: 1,
                color: "#ff974c10",
              },
            ],
            false
          ),
        },
      },
      data: dataValue,
    },
    {
      name: "出售热度",
      type: "line",
      symbol: "circle", // 默认是空心圆（中间是白色的），改成实心圆
      smooth: true,
      lineStyle: {
        normal: {
          width: 2,
          color: "#00eaff", // 线条颜色
        },
      },
      itemStyle: {
        normal: {
          label: {
            show: false, //开启显示
            color: "#fff",
            position: "bottom", //在上方显示
            formatter: function (res) {
              if (res.value) {
                return res.value;
              } else {
                return 0;
              }
            },
          },
        },
      },
      symbolSize: 0, //设定实心点的大小
      areaStyle: {
        normal: {
          //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "#00eaff30",
              },
              {
                offset: 0.6,
                color: "#00eaff20",
              },
              {
                offset: 1,
                color: "#00eaff10",
              },
            ],
            false
          ),
        },
      },
      data: dataValue1,
    },
  ],
};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);

    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
